import ajax from './http'

const groupServer = {
  // 获取拼团购商品
  getGroupList (params) {
    return ajax({
      url: '/commodity/getGroupBuyGood',
      type: 'get',
      params: params
    })
  },
  // 根据团单号，获取团单详情
  getSpellGroupDetail(params) {
    return ajax({
      url: '/commodity/getGroupBuyCommInfo',
      type: 'get',
      params: params
    })
  }

}

export default groupServer